import { render, staticRenderFns } from "./TrainingList.vue?vue&type=template&id=67087dca"
import script from "./TrainingList.vue?vue&type=script&lang=js"
export * from "./TrainingList.vue?vue&type=script&lang=js"
import style0 from "./TrainingList.vue?vue&type=style&index=0&id=67087dca&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports